import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog,  MatDialogRef } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ColorBotonDirective } from 'app/directives/style/color-boton.directive';
import { PasarApoyoComponent } from 'app/modals/pasar-apoyo/pasar-apoyo.component';
import { PasarRefuerzoComponent } from 'app/modals/pasar-refuerzo/pasar-refuerzo.component';

@Component({
  selector: 'app-benef-x-titular',
  templateUrl: './benef-x-titular.component.html',
  styleUrls: ['./benef-x-titular.component.scss']
})
export class BenefXTitularComponent implements OnInit {
  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  constructor(@Inject(MAT_DIALOG_DATA) private data, private _informe:InformesService, private dialog: MatDialog) {
    this.dtTrigger = new Subject();

    this.tableOpt = [];
    this.dtOptions = {
      columns: [
        {
          title: ''
        },
        {
          title: 'Promedio Servicio Adecuado',
          data: 'promeServAde'
        },
        {
          title: 'Servicio Adecuado Total',
          data: 'servAdeTotal'
        },
        {
          title: 'Meses',
          data: 'PerTiempoBen'
        },
        {
          title: 'Documento',
          data: 'bendoc'
        },
        {
          title: 'Nombre',
          data: 'bennom'
        },
        {
          title: 'Total Servicios',
          data: 'total_servicios'
        },
        {
          title: 'Radicado',
          data: 'grugru'
        },
        {
          title: 'ID Titular',
          data: 'ID_Titular'
        },
        {
          title: 'ID Grupo',
          data: 'id_grupo'
        },
        {
          title: 'Ingreso',
          data: 'bening'
        }
      ]
    }
  }

  ngOnInit() {
    this._informe.BeneficiariosxTitular(this.data.fecha_inicio, this.data.fecha_final, this.data.titular_id).subscribe((dato:any) => {
      this.tableOpt = dato.resultado;
      this.dtTrigger.next();
    });
  }

  public opcionModal(opc, documento, indice){
    let modal;
    switch(opc){
      case 'pasar-apoyo':
        modal = this.dialog.open(PasarApoyoComponent, {
          data: {
            document: documento
          }
        });
        break;
      case 'pasar-refuerzo':
        modal = this.dialog.open(PasarRefuerzoComponent, {
          width: '30%',
          height: '25%',
          data: {
            document: documento
          }
        });
        break;
    }
    modal.afterClosed().subscribe(result => {
      if(result == true){
        this.tableOpt[indice].ApoyoUsuario = "1";
      }
    });
  }

}
